import React, { useState, useEffect } from 'react';

const EditorDashboard: React.FC = () => (
  <div className="container pt-1 main-container-div">EditorDashboard</div>
);

export default EditorDashboard;
